import React, { useState } from "react"; 
import { createTask } from "../../api/api"; 
const TaskForm = ({ project_id, onTaskCreated }) => 
  { const [description, setDescription] = useState(""); 
    const [assignedTo, setAssignedTo] = useState(""); 
    const [status, setStatus] = useState("pending"); 
    const [priority, setPriority] = useState("medium"); 
    const [loading, setLoading] = useState(false); 
    const handleSubmit = async (e) => { e.preventDefault(); 
      if (!description) return alert("Task description is required"); 
      setLoading(true); try { await createTask(project_id, description, assignedTo || null, status, priority); 
        onTaskCreated(); 
        setDescription(""); 
        setAssignedTo(""); 
        setStatus("pending"); 
        setPriority("medium"); 
      } 
        catch (err) { console.error(err); 
          alert("Failed to create task"); 
        } finally { setLoading(false); } }; 
        return (
        <div className="card mb-4 shadow-sm"> 
        <div className="card-body"> 
          <h5 className="card-title mb-3">Create New Task</h5> 
          <form onSubmit={handleSubmit}> 
            <input className="form-control mb-2" placeholder="Task Description" value={description} onChange={(e) => setDescription(e.target.value)} required /> 
            <input className="form-control mb-2" placeholder="Assign to User ID (optional)" value={assignedTo} onChange={(e) => setAssignedTo(e.target.value)} /> 
            <div className="d-flex gap-2 mb-2"> 
              <select className="form-select" value={status} onChange={(e) => setStatus(e.target.value)} > 
                <option value="pending">Pending</option> 
                <option value="in_progress">In Progress</option> 
                <option value="completed">Completed</option> 
              </select> 
              <select className="form-select" value={priority} onChange={(e) => setPriority(e.target.value)} > 
                <option value="low">Low</option> 
                <option value="medium">Medium</option> 
                <option value="high">High</option> 
              </select> </div> <button className="btn btn-primary" disabled={loading}> 
                {loading ? "Creating..." : "Create Task"} </button> 
            </form> 
            </div> 
        </div>); }; 
        
        export default TaskForm;